import { IconButton, MinusIcon } from "@dealer-center/core-components";
import { useSearchParams } from "react-router-dom";
import {
  AdvancedFiltersSelectionWrapper,
  StyledFilter
} from "./AdvancedFiltersStyles";
import type { AdvancedFiltersSelectionProps } from "@dealer-center/ddc-pages-inventory-archiver-interface";
import FilterField from "./FilterField";

const AdvancedFiltersSelection = (props: AdvancedFiltersSelectionProps) => {
  const [searchParams] = useSearchParams();

  return (
    <AdvancedFiltersSelectionWrapper>
      {props.selectedFilters.map(selectedFilter => {
        const config = props.filters[selectedFilter.name];
        return (
          <StyledFilter key={selectedFilter.name}>
            <FilterField
              config={config}
              value={searchParams.get(selectedFilter.name) ?? ""}
              onChange={(value: string) =>
                props.onChange(selectedFilter.name, value)
              }
            />
            <IconButton
              buttonStyle="primary"
              size="md"
              onClick={() => props.handleRemoveFilter(selectedFilter.name)}
            >
              <MinusIcon title="Remove" />
            </IconButton>
          </StyledFilter>
        );
      })}
    </AdvancedFiltersSelectionWrapper>
  );
};

export default AdvancedFiltersSelection;
